import React, { useState } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';

const SellPaymentReport = () => {
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [showExportDropdown, setShowExportDropdown] = useState(false);

    const handleExport = (format) => {
        const headers = ['Reference No', 'Paid on', 'Amount', 'Customer', 'Customer Group', 'Payment Method', 'Sell'];
        const rows = mockData.map(r => [
            r.refNo || '', r.paidOn || '', r.amount || '', r.customer || '', r.customerGroup || '',
            r.paymentMethod?.replace(/\n/g, ' ') || '', r.sell || ''
        ]);

        const title = 'Sell Payment Report';
        const filename = 'sell_payment_report';

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();

        setShowExportDropdown(false);
    };

    // Mock data matching the screenshot
    const mockData = [
        {
            refNo: 'SP2026/0489',
            paidOn: '01/06/2026 12:30 PM',
            amount: '$ 12.00',
            customer: 'Mr apple',
            customerGroup: '',
            paymentMethod: 'Cheque\n(Cheque No.: 48745)',
            sell: '0104'
        },
        {
            refNo: 'SP2026/0485',
            paidOn: '01/06/2026 11:43 AM',
            amount: '$ 33.00',
            customer: 'Mr apple',
            customerGroup: '',
            paymentMethod: 'Cheque\n(Cheque No.: 5452154)',
            sell: '15484152'
        },
        {
            refNo: 'SP2026/0484',
            paidOn: '01/05/2026 02:35 PM',
            amount: '$ 34.00',
            customer: 'Mr redmi',
            customerGroup: '',
            paymentMethod: 'Cheque\n(Cheque No.: 1215212)',
            sell: '25421'
        },
        {
            refNo: 'SP2026/0483',
            paidOn: '01/05/2026 02:30 PM',
            amount: '$ 60.00',
            customer: 'Motorola',
            customerGroup: '',
            paymentMethod: 'Cash',
            sell: '0103'
        },
        {
            refNo: 'SP2026/0482',
            paidOn: '01/05/2026 02:27 PM',
            amount: '$ 76.00',
            customer: 'Motorola',
            customerGroup: '',
            paymentMethod: 'Cash',
            sell: '2565'
        },
        {
            hasPlus: true,
            refNo: 'SP2026/0479',
            paidOn: '01/05/2026 02:23 PM',
            amount: '$ 175.00',
            customer: '',
            customerGroup: '',
            paymentMethod: 'Cash',
            sell: ''
        },
        {
            refNo: 'SP2026/0478',
            paidOn: '01/05/2026 01:47 PM',
            amount: '$ 70.00',
            customer: 'Motorola',
            customerGroup: '',
            paymentMethod: 'Cheque\n(Cheque No.: 12345678)',
            sell: '0102'
        },
        {
            refNo: 'SP2026/0477',
            paidOn: '01/05/2026 10:13 AM',
            amount: '$ 0.00',
            customer: 'Mr 5-jan',
            customerGroup: '',
            paymentMethod: 'Cheque',
            sell: '565323'
        }
    ];

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Sell Payment Table Container ── */}
            <div style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>

                {/* Table controls */}
                <div className="table-controls" style={{ borderBottom: '1px solid #e2e8f0', padding: '1rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select">
                            <span>Show</span>
                            <select value={entriesPerPage} onChange={e => setEntriesPerPage(Number(e.target.value))}>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>

                    <div className="table-controls-right">
                        {/* Single Export dropdown */}
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button
                                className="export-btn"
                                onClick={() => setShowExportDropdown(!showExportDropdown)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '0.4rem',
                                    padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0',
                                    borderRadius: '6px', background: '#fff', cursor: 'pointer',
                                    fontSize: '0.85rem', color: '#334155'
                                }}
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Export ▾
                            </button>
                            {showExportDropdown && (
                                <div className="export-dropdown-menu" style={{
                                    position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem',
                                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', zIndex: 10, minWidth: '160px'
                                }}>
                                    {[
                                        { icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport('CSV') },
                                        { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport('Excel') },
                                        { icon: 'fa-print', label: 'Print', action: () => handleExport('Print') },
                                        { icon: 'fa-table', label: 'Column visibility' },
                                        { icon: 'fa-file-pdf-o', label: 'Export PDF', action: () => handleExport('PDF') },
                                    ].map((item, i) => (
                                        <button
                                            key={i}
                                            onClick={() => { if (item.action) item.action(); setShowExportDropdown(false); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.5rem',
                                                width: '100%', padding: '0.5rem 1rem', border: 'none',
                                                background: 'none', textAlign: 'left', cursor: 'pointer',
                                                fontSize: '0.8125rem', color: '#475569'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search ..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                width: '180px',
                            }}
                        />
                    </div>
                </div>

                {/* Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '15%' }}>Reference No <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '18%' }}>Paid on <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '10%' }}>Amount <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '12%' }}>Customer</th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '15%' }}>Customer Group <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '15%' }}>Payment Method <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '10%' }}>Sell <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', width: '5%', textAlign: 'center' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mockData.map((row, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', verticalAlign: 'top', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        {row.hasPlus && (
                                            <i className="fa fa-plus-circle" style={{ color: '#22c55e', fontSize: '1rem', cursor: 'pointer' }} />
                                        )}
                                        {row.refNo}
                                    </td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', verticalAlign: 'top' }}>{row.paidOn}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '500', verticalAlign: 'top' }}>{row.amount}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', verticalAlign: 'top' }}>{row.customer}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', verticalAlign: 'top' }}>{row.customerGroup}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'pre-line', verticalAlign: 'top' }}>{row.paymentMethod}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#3b82f6', cursor: 'pointer', verticalAlign: 'top' }}>{row.sell}</td>
                                    <td style={{ padding: '0.75rem 1rem', textAlign: 'center', verticalAlign: 'top' }}>
                                        <button style={{
                                            padding: '0.25rem 0.75rem',
                                            background: '#fff',
                                            border: '1px solid #a855f7',
                                            color: '#a855f7',
                                            borderRadius: '4px',
                                            fontSize: '0.75rem',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}>
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid #e2e8f0' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem' }}>
                        Showing 1 to 8 of 8 entries
                    </div>
                    <div className="pagination-controls">
                        <button className="page-btn disabled">Previous</button>
                        <button className="page-btn active">1</button>
                        <button className="page-btn disabled">Next</button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SellPaymentReport;
